export default
[
    {"label": "Afghanistan", "code": "+93", "alpha2": "AF"},
    {"label": "Aland Islands", "code": "+358", "alpha2": "AX"},
    {"label": "Albania", "code": "+355", "alpha2": "AL"},
    {"label": "Algeria", "code": "+213", "alpha2": "DZ"},
    {"label": "AmericanSamoa", "code": "+1 684", "alpha2": "AS"},
    {"label": "Andorra", "code": "+376", "alpha2": "AD"},
    {"label": "Angola", "code": "+244", "alpha2": "AO"},
    {"label": "Anguilla", "code": "+1 264", "alpha2": "AI"},
    {"label": "Antarctica", "code": "+672", "alpha2": "AQ"},
    {"label": "Antigua and Barbuda", "code": "+1268", "alpha2": "AG"},
    {"label": "Argentina", "code": "+54", "alpha2": "AR"},
    {"label": "Armenia", "code": "+374", "alpha2": "AM"},
    {"label": "Aruba", "code": "+297", "alpha2": "AW"},
    {"label": "Australia", "code": "+61", "alpha2": "AU"},
    {"label": "Austria", "code": "+43", "alpha2": "AT"},
    {"label": "Azerbaijan", "code": "+994", "alpha2": "AZ"},
    {"label": "Bahamas", "code": "+1 242", "alpha2": "BS"},
    {"label": "Bahrain", "code": "+973", "alpha2": "BH"},
    {"label": "Bangladesh", "code": "+880", "alpha2": "BD"},
    {"label": "Barbados", "code": "+1 246", "alpha2": "BB"},
    {"label": "Belarus", "code": "+375", "alpha2": "BY"},
    {"label": "Belgium", "code": "+32", "alpha2": "BE"},
    {"label": "Belize", "code": "+501", "alpha2": "BZ"},
    {"label": "Benin", "code": "+229", "alpha2": "BJ"},
    {"label": "Bermuda", "code": "+1 441", "alpha2": "BM"},
    {"label": "Bhutan", "code": "+975", "alpha2": "BT"},
    {"label": "Bolivia, Plurinational State of", "code": "+591", "alpha2": "BO"},
    {"label": "Bosnia and Herzegovina", "code": "+387", "alpha2": "BA"},
    {"label": "Botswana", "code": "+267", "alpha2": "BW"},
    {"label": "Brazil", "code": "+55", "alpha2": "BR"},
    {"label": "British Indian Ocean Territory", "code": "+246", "alpha2": "IO"},
    {"label": "Brunei Darussalam", "code": "+673", "alpha2": "BN"},
    {"label": "Bulgaria", "code": "+359", "alpha2": "BG"},
    {"label": "Burkina Faso", "code": "+226", "alpha2": "BF"},
    {"label": "Burundi", "code": "+257", "alpha2": "BI"},
    {"label": "Cambodia", "code": "+855", "alpha2": "KH"},
    {"label": "Cameroon", "code": "+237", "alpha2": "CM"},
    {"label": "Canada", "code": "+1", "alpha2": "CA"},
    {"label": "Cape Verde", "code": "+238", "alpha2": "CV"},
    {"label": "Cayman Islands", "code": "+ 345", "alpha2": "KY"},
    {"label": "Central African Republic", "code": "+236", "alpha2": "CF"},
    {"label": "Chad", "code": "+235", "alpha2": "TD"},
    {"label": "Chile", "code": "+56", "alpha2": "CL"},
    {"label": "China", "code": "+86", "alpha2": "CN"},
    {"label": "Christmas Island", "code": "+61", "alpha2": "CX"},
    {"label": "Cocos (Keeling) Islands", "code": "+61", "alpha2": "CC"},
    {"label": "Colombia", "code": "+57", "alpha2": "CO"},
    {"label": "Comoros", "code": "+269", "alpha2": "KM"},
    {"label": "Congo", "code": "+242", "alpha2": "CG"},
    {"label": "Congo, The Democratic Republic of the Congo", "code": "+243", "alpha2": "CD"},
    {"label": "Cook Islands", "code": "+682", "alpha2": "CK"},
    {"label": "Costa Rica", "code": "+506", "alpha2": "CR"},
    {"label": "Cote d'Ivoire", "code": "+225", "alpha2": "CI"},
    {"label": "Croatia", "code": "+385", "alpha2": "HR"},
    {"label": "Cuba", "code": "+53", "alpha2": "CU"},
    {"label": "Cyprus", "code": "+357", "alpha2": "CY"},
    {"label": "Czech Republic", "code": "+420", "alpha2": "CZ"},
    {"label": "Denmark", "code": "+45", "alpha2": "DK"},
    {"label": "Djibouti", "code": "+253", "alpha2": "DJ"},
    {"label": "Dominica", "code": "+1 767", "alpha2": "DM"},
    {"label": "Dominican Republic", "code": "+1 849", "alpha2": "DO"},
    {"label": "Ecuador", "code": "+593", "alpha2": "EC"},
    {"label": "Egypt", "code": "+20", "alpha2": "EG"},
    {"label": "El Salvador", "code": "+503", "alpha2": "SV"},
    {"label": "Equatorial Guinea", "code": "+240", "alpha2": "GQ"},
    {"label": "Eritrea", "code": "+291", "alpha2": "ER"},
    {"label": "Estonia", "code": "+372", "alpha2": "EE"},
    {"label": "Ethiopia", "code": "+251", "alpha2": "ET"},
    {"label": "Falkland Islands (Malvinas)", "code": "+500", "alpha2": "FK"},
    {"label": "Faroe Islands", "code": "+298", "alpha2": "FO"},
    {"label": "Fiji", "code": "+679", "alpha2": "FJ"},
    {"label": "Finland", "code": "+358", "alpha2": "FI"},
    {"label": "France", "code": "+33", "alpha2": "FR"},
    {"label": "French Guiana", "code": "+594", "alpha2": "GF"},
    {"label": "French Polynesia", "code": "+689", "alpha2": "PF"},
    {"label": "Gabon", "code": "+241", "alpha2": "GA"},
    {"label": "Gambia", "code": "+220", "alpha2": "GM"},
    {"label": "Georgia", "code": "+995", "alpha2": "GE"},
    {"label": "Germany", "code": "+49", "alpha2": "DE"},
    {"label": "Ghana", "code": "+233", "alpha2": "GH"},
    {"label": "Gibraltar", "code": "+350", "alpha2": "GI"},
    {"label": "Greece", "code": "+30", "alpha2": "GR"},
    {"label": "Greenland", "code": "+299", "alpha2": "GL"},
    {"label": "Grenada", "code": "+1 473", "alpha2": "GD"},
    {"label": "Guadeloupe", "code": "+590", "alpha2": "GP"},
    {"label": "Guam", "code": "+1 671", "alpha2": "GU"},
    {"label": "Guatemala", "code": "+502", "alpha2": "GT"},
    {"label": "Guernsey", "code": "+44", "alpha2": "GG"},
    {"label": "Guinea", "code": "+224", "alpha2": "GN"},
    {"label": "Guinea-Bissau", "code": "+245", "alpha2": "GW"},
    {"label": "Guyana", "code": "+595", "alpha2": "GY"},
    {"label": "Haiti", "code": "+509", "alpha2": "HT"},
    {"label": "Holy See (Vatican City State)", "code": "+379", "alpha2": "VA"},
    {"label": "Honduras", "code": "+504", "alpha2": "HN"},
    {"label": "Hong Kong", "code": "+852", "alpha2": "HK"},
    {"label": "Hungary", "code": "+36", "alpha2": "HU"},
    {"label": "Iceland", "code": "+354", "alpha2": "IS"},
    {"label": "India", "code": "+91", "alpha2": "IN"},
    {"label": "Indonesia", "code": "+62", "alpha2": "ID"},
    {"label": "Iran, Islamic Republic of Persian Gulf", "code": "+98", "alpha2": "IR"},
    {"label": "Iraq", "code": "+964", "alpha2": "IQ"},
    {"label": "Ireland", "code": "+353", "alpha2": "IE"},
    {"label": "Isle of Man", "code": "+44", "alpha2": "IM"},
    {"label": "Israel", "code": "+972", "alpha2": "IL"},
    {"label": "Italy", "code": "+39", "alpha2": "IT"},
    {"label": "Jamaica", "code": "+1 876", "alpha2": "JM"},
    {"label": "Japan", "code": "+81", "alpha2": "JP"},
    {"label": "Jersey", "code": "+44", "alpha2": "JE"},
    {"label": "Jordan", "code": "+962", "alpha2": "JO"},
    {"label": "Kazakhstan", "code": "+7 7", "alpha2": "KZ"},
    {"label": "Kenya", "code": "+254", "alpha2": "KE"},
    {"label": "Kiribati", "code": "+686", "alpha2": "KI"},
    {"label": "Korea, Democratic People's Republic of Korea", "code": "+850", "alpha2": "KP"},
    {"label": "Korea, Republic of South Korea", "code": "+82", "alpha2": "KR"},
    {"label": "Kuwait", "code": "+965", "alpha2": "KW"},
    {"label": "Kyrgyzstan", "code": "+996", "alpha2": "KG"},
    {"label": "Laos", "code": "+856", "alpha2": "LA"},
    {"label": "Latvia", "code": "+371", "alpha2": "LV"},
    {"label": "Lebanon", "code": "+961", "alpha2": "LB"},
    {"label": "Lesotho", "code": "+266", "alpha2": "LS"},
    {"label": "Liberia", "code": "+231", "alpha2": "LR"},
    {"label": "Libyan Arab Jamahiriya", "code": "+218", "alpha2": "LY"},
    {"label": "Liechtenstein", "code": "+423", "alpha2": "LI"},
    {"label": "Lithuania", "code": "+370", "alpha2": "LT"},
    {"label": "Luxembourg", "code": "+352", "alpha2": "LU"},
    {"label": "Macao", "code": "+853", "alpha2": "MO"},
    {"label": "Macedonia", "code": "+389", "alpha2": "MK"},
    {"label": "Madagascar", "code": "+261", "alpha2": "MG"},
    {"label": "Malawi", "code": "+265", "alpha2": "MW"},
    {"label": "Malaysia", "code": "+60", "alpha2": "MY"},
    {"label": "Maldives", "code": "+960", "alpha2": "MV"},
    {"label": "Mali", "code": "+223", "alpha2": "ML"},
    {"label": "Malta", "code": "+356", "alpha2": "MT"},
    {"label": "Marshall Islands", "code": "+692", "alpha2": "MH"},
    {"label": "Martinique", "code": "+596", "alpha2": "MQ"},
    {"label": "Mauritania", "code": "+222", "alpha2": "MR"},
    {"label": "Mauritius", "code": "+230", "alpha2": "MU"},
    {"label": "Mayotte", "code": "+262", "alpha2": "YT"},
    {"label": "Mexico", "code": "+52", "alpha2": "MX"},
    {"label": "Micronesia, Federated States of Micronesia", "code": "+691", "alpha2": "FM"},
    {"label": "Moldova", "code": "+373", "alpha2": "MD"},
    {"label": "Monaco", "code": "+377", "alpha2": "MC"},
    {"label": "Mongolia", "code": "+976", "alpha2": "MN"},
    {"label": "Montenegro", "code": "+382", "alpha2": "ME"},
    {"label": "Montserrat", "code": "+1664", "alpha2": "MS"},
    {"label": "Morocco", "code": "+212", "alpha2": "MA"},
    {"label": "Mozambique", "code": "+258", "alpha2": "MZ"},
    {"label": "Myanmar", "code": "+95", "alpha2": "MM"},
    {"label": "Namibia", "code": "+264", "alpha2": "NA"},
    {"label": "Nauru", "code": "+674", "alpha2": "NR"},
    {"label": "Nepal", "code": "+977", "alpha2": "NP"},
    {"label": "Netherlands", "code": "+31", "alpha2": "NL"},
    {"label": "Netherlands Antilles", "code": "+599", "alpha2": "AN"},
    {"label": "New Caledonia", "code": "+687", "alpha2": "NC"},
    {"label": "New Zealand", "code": "+64", "alpha2": "NZ"},
    {"label": "Nicaragua", "code": "+505", "alpha2": "NI"},
    {"label": "Niger", "code": "+227", "alpha2": "NE"},
    {"label": "Nigeria", "code": "+234", "alpha2": "NG"},
    {"label": "Niue", "code": "+683", "alpha2": "NU"},
    {"label": "Norfolk Island", "code": "+672", "alpha2": "NF"},
    {"label": "Northern Mariana Islands", "code": "+1 670", "alpha2": "MP"},
    {"label": "Norway", "code": "+47", "alpha2": "NO"},
    {"label": "Oman", "code": "+968", "alpha2": "OM"},
    {"label": "Pakistan", "code": "+92", "alpha2": "PK"},
    {"label": "Palau", "code": "+680", "alpha2": "PW"},
    {"label": "Palestinian Territory, Occupied", "code": "+970", "alpha2": "PS"},
    {"label": "Panama", "code": "+507", "alpha2": "PA"},
    {"label": "Papua New Guinea", "code": "+675", "alpha2": "PG"},
    {"label": "Paraguay", "code": "+595", "alpha2": "PY"},
    {"label": "Peru", "code": "+51", "alpha2": "PE"},
    {"label": "Philippines", "code": "+63", "alpha2": "PH"},
    {"label": "Pitcairn", "code": "+872", "alpha2": "PN"},
    {"label": "Poland", "code": "+48", "alpha2": "PL"},
    {"label": "Portugal", "code": "+351", "alpha2": "PT"},
    {"label": "Puerto Rico", "code": "+1 939", "alpha2": "PR"},
    {"label": "Qatar", "code": "+974", "alpha2": "QA"},
    {"label": "Romania", "code": "+40", "alpha2": "RO"},
    {"label": "Russia", "code": "+7", "alpha2": "RU"},
    {"label": "Rwanda", "code": "+250", "alpha2": "RW"},
    {"label": "Reunion", "code": "+262", "alpha2": "RE"},
    {"label": "Saint Barthelemy", "code": "+590", "alpha2": "BL"},
    {"label": "Saint Helena, Ascension and Tristan Da Cunha", "code": "+290", "alpha2": "SH"},
    {"label": "Saint Kitts and Nevis", "code": "+1 869", "alpha2": "KN"},
    {"label": "Saint Lucia", "code": "+1 758", "alpha2": "LC"},
    {"label": "Saint Martin", "code": "+590", "alpha2": "MF"},
    {"label": "Saint Pierre and Miquelon", "code": "+508", "alpha2": "PM"},
    {"label": "Saint Vincent and the Grenadines", "code": "+1 784", "alpha2": "VC"},
    {"label": "Samoa", "code": "+685", "alpha2": "WS"},
    {"label": "San Marino", "code": "+378", "alpha2": "SM"},
    {"label": "Sao Tome and Principe", "code": "+239", "alpha2": "ST"},
    {"label": "Saudi Arabia", "code": "+966", "alpha2": "SA"},
    {"label": "Senegal", "code": "+221", "alpha2": "SN"},
    {"label": "Serbia", "code": "+381", "alpha2": "RS"},
    {"label": "Seychelles", "code": "+248", "alpha2": "SC"},
    {"label": "Sierra Leone", "code": "+232", "alpha2": "SL"},
    {"label": "Singapore", "code": "+65", "alpha2": "SG"},
    {"label": "Slovakia", "code": "+421", "alpha2": "SK"},
    {"label": "Slovenia", "code": "+386", "alpha2": "SI"},
    {"label": "Solomon Islands", "code": "+677", "alpha2": "SB"},
    {"label": "Somalia", "code": "+252", "alpha2": "SO"},
    {"label": "South Africa", "code": "+27", "alpha2": "ZA"},
    {"label": "South Georgia and the South Sandwich Islands", "code": "+500", "alpha2": "GS"},
    {"label": "Spain", "code": "+34", "alpha2": "ES"},
    {"label": "Sri Lanka", "code": "+94", "alpha2": "LK"},
    {"label": "Sudan", "code": "+249", "alpha2": "SD"},
    {"label": "Suriname", "code": "+597", "alpha2": "SR"},
    {"label": "Svalbard and Jan Mayen", "code": "+47", "alpha2": "SJ"},
    {"label": "Swaziland", "code": "+268", "alpha2": "SZ"},
    {"label": "Sweden", "code": "+46", "alpha2": "SE"},
    {"label": "Switzerland", "code": "+41", "alpha2": "CH"},
    {"label": "Syrian Arab Republic", "code": "+963", "alpha2": "SY"},
    {"label": "Taiwan", "code": "+886", "alpha2": "TW"},
    {"label": "Tajikistan", "code": "+992", "alpha2": "TJ"},
    {"label": "Tanzania, United Republic of Tanzania", "code": "+255", "alpha2": "TZ"},
    {"label": "Thailand", "code": "+66", "alpha2": "TH"},
    {"label": "Timor-Leste", "code": "+670", "alpha2": "TL"},
    {"label": "Togo", "code": "+228", "alpha2": "TG"},
    {"label": "Tokelau", "code": "+690", "alpha2": "TK"},
    {"label": "Tonga", "code": "+676", "alpha2": "TO"},
    {"label": "Trinidad and Tobago", "code": "+1 868", "alpha2": "TT"},
    {"label": "Tunisia", "code": "+216", "alpha2": "TN"},
    {"label": "Turkey", "code": "+90", "alpha2": "TR"},
    {"label": "Turkmenistan", "code": "+993", "alpha2": "TM"},
    {"label": "Turks and Caicos Islands", "code": "+1 649", "alpha2": "TC"},
    {"label": "Tuvalu", "code": "+688", "alpha2": "TV"},
    {"label": "Uganda", "code": "+256", "alpha2": "UG"},
    {"label": "Ukraine", "code": "+380", "alpha2": "UA"},
    {"label": "United Arab Emirates", "code": "+971", "alpha2": "AE"},
    {"label": "United Kingdom", "code": "+44", "alpha2": "GB"},
    {"label": "United States", "code": "+1", "alpha2": "US"},
    {"label": "Uruguay", "code": "+598", "alpha2": "UY"},
    {"label": "Uzbekistan", "code": "+998", "alpha2": "UZ"},
    {"label": "Vanuatu", "code": "+678", "alpha2": "VU"},
    {"label": "Venezuela, Bolivarian Republic of Venezuela", "code": "+58", "alpha2": "VE"},
    {"label": "Vietnam", "code": "+84", "alpha2": "VN"},
    {"label": "Virgin Islands, British", "code": "+1 284", "alpha2": "VG"},
    {"label": "Virgin Islands, U.S.", "code": "+1 340", "alpha2": "VI"},
    {"label": "Wallis and Futuna", "code": "+681", "alpha2": "WF"},
    {"label": "Yemen", "code": "+967", "alpha2": "YE"},
    {"label": "Zambia", "code": "+260", "alpha2": "ZM"},
    {"label": "Zimbabwe", "code": "+263", "alpha2": "ZW"}
];